/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Save': {
    width: 8,
    height: 8,
    viewBox: '0 0 8 8',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" _fill="#376F99" d="M0 0h5.337l1.78 1.44V7.11H0z"/><path pid="1" _fill="#FFF" d="M1 1h4.402l.903.872V6.23H1z"/><path pid="2" _stroke="#376F99" d="M2 .5v1.712h2.171V.5M2 6.657V4.5h3.3v2.157"/></g>'
  }
})
